import { Phone, Mail, MapPin } from "lucide-react";
import { BRAND, NAV_LINKS, SERVICES } from "@/lib/site";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-slate-950 text-slate-300 pt-16 pb-10 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid md:grid-cols-12 gap-10">
          {/* Brand */}
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <div className="h-11 w-11 rounded-xl bg-white grid place-items-center overflow-hidden">
                <img
                  src={BRAND.logo}
                  alt="Virtue Registration Services"
                  className="h-9 w-9 object-contain"
                />
              </div>
              <div>
                <div className="font-display font-semibold text-white text-base">
                  {BRAND.name}
                </div>
                <div className="text-xs uppercase tracking-[0.18em] text-slate-500 mt-0.5">
                  Skip the DMV
                </div>
              </div>
            </div>
            <p className="mt-6 text-sm text-slate-400 leading-relaxed max-w-md">
              San Diego's friendly, fast, and trusted private DMV registration service.
              Registrations, title transfers, and VIN verifications — done right the first time.
            </p>
            <div className="mt-6 space-y-2 text-sm">
              <a
                href={BRAND.phoneHref}
                className="flex items-center gap-3 text-slate-300 hover:text-white"
              >
                <Phone className="h-4 w-4 text-blue-400" /> {BRAND.phone}
              </a>
              <a
                href={BRAND.emailHref}
                className="flex items-center gap-3 text-slate-300 hover:text-white break-all"
              >
                <Mail className="h-4 w-4 text-blue-400" /> {BRAND.email}
              </a>
              <a
                href={BRAND.mapsUrl}
                target="_blank"
                rel="noreferrer"
                className="flex items-start gap-3 text-slate-300 hover:text-white"
              >
                <MapPin className="h-4 w-4 mt-0.5 text-blue-400" />
                <span>{BRAND.address}</span>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.22em] text-slate-500 font-bold">
              Navigate
            </div>
            <ul className="mt-5 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="text-sm text-slate-300 hover:text-white transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href="#book"
                  className="text-sm text-blue-400 hover:text-blue-300 font-semibold"
                >
                  Book an Appointment →
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div className="md:col-span-4">
            <div className="text-xs uppercase tracking-[0.22em] text-slate-500 font-bold">
              Services
            </div>
            <ul className="mt-5 grid grid-cols-1 gap-y-2.5 text-sm">
              {SERVICES.map((s) => (
                <li key={s.value}>
                  <a
                    href="#services"
                    className="text-slate-300 hover:text-white transition-colors"
                  >
                    {s.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs text-slate-500">
          <div>
            © {new Date().getFullYear()} {BRAND.name}. All rights reserved.
          </div>
          <div className="flex items-center gap-5">
            <span>Licensed California Private DMV Partner</span>
            <span className="hidden sm:inline">·</span>
            <span>San Diego, CA</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
